import SignupPageToken from '@apps/maha/admin/tokens/signup_page'
import Panel from '@admin/components/panel'
import Clone from './clone'
import Edit from './edit'
import React from 'react'
import New from './new'

const mapPropsToPanel = (props, context) => ({
  title: 't(Signup Pages)',
  collection: {
    endpoint: '/api/admin/truevail/admin/signup_pages',
    table: [
      { label: 't(ID)', key: 'id', collapsing: true, visible: false },
      { label: 't(Title)', key: 'title', primary: true, format: (signup_page) => (
        <SignupPageToken signup_page={ signup_page } />
      ) }
    ],
    defaultSort: { key: 'title', order: 'desc' },
    empty: {
      icon: 'file-o',
      title: 't(No Signup Pages)',
      text: 't(You have not yet created any signup pages)',
      buttons: [
        { 
          label: 't(Create Signup Page)', 
          modal: New 
        }
      ]
    },
    entity: 'signup page',
    recordTasks: (record) => [
      {
        label: 't(Edit Signup Page)',
        svg: 'square_pen',
        modal: <Edit signup_page={ record } />
      },
      {
        label: 't(Duplicate Signup Page)',
        svg: 'copy',
        modal: <Clone signup_page={ record } />
      },
      {
        label: 't(Delete Signup Page)',
        svg: 'trash',
        confirm: 't(Are you sure you want to delete this signup page?)',
        deletable: true,
        request: {
          endpoint: `/api/admin/truevail/admin/signup_pages/${record.id}`,
          method: 'DELETE',
          onFailure: (result) => context.flash.set('error', 'Unable to delete signup page'),
          onSuccess: (result) => context.flash.set('success', 'Signup page was deleted successfully')
        }
      }
    ],
    onClick: (record) => context.router.push(`/admin/truevail/admin/signup_pages/${record.id}`)
  },
  task: {
    svg: 'plus',
    modal: New
  }
})

export default Panel(null, mapPropsToPanel)
